import { getLocaleIndexRouteName } from '@/config/routeDefaults'

/**
 * 挂在 /:locale(zh|ja) 下的 C 端子路由（path 为相对路径）
 */
export default [
  {
    path: '',
    redirect: (to) => ({
      name: getLocaleIndexRouteName(),
      params: { locale: to.params.locale }
    })
  },
  {
    path: 'home',
    name: 'home',
    component: () => import('@/views/pc/Home')
  },
  {
    path: 'register',
    name: 'register',
    component: () => import('@/views/pc/Register')
  },
  {
    path: 'login',
    name: 'login',
    component: () => import('@/views/pc/Login')
  },
  {
    path: 'forgot-password',
    name: 'forgotPassword',
    component: () => import('@/views/pc/ForgotPassword')
  },
  {
    path: 'reset-password',
    name: 'resetPassword',
    component: () => import('@/views/pc/ResetPassword')
  },
  {
    path: 'feadback',
    name: 'feadback',
    component: () => import('@/views/pc/FeadBack')
  },
  {
    path: 'bookclass',
    name: 'bookclass',
    component: () => import('@/views/pc/BookClass')
  },
  {
    path: 'm/home',
    name: 'mobileHome',
    component: () => import('@/views/mobile/Home')
  },
  {
    path: 'm/login',
    name: 'mobileLogin',
    component: () => import('@/views/mobile/Login')
  },
  {
    path: 'm/register',
    name: 'mobileRegister',
    component: () => import('@/views/mobile/Register')
  },
  {
    path: 'm/forgot-password',
    name: 'mobileForgotPassword',
    component: () => import('@/views/mobile/ForgotPassword')
  },
  {
    path: 'm/reset-password',
    name: 'mobileResetPassword',
    component: () => import('@/views/mobile/ResetPassword')
  },
  {
    path: 'm/bookclass',
    name: 'mobileBookclass',
    component: () => import('@/views/mobile/BookClass')
  },
  {
    path: 'm/book_rank',
    name: 'mobileBookRank',
    component: () => import('@/views/mobile/BookRank')
  },
  {
    path: 'book_rank',
    name: 'bookRank',
    component: () => import('@/views/pc/BookRank')
  },
  {
    path: 'book/:id',
    name: 'book',
    component: () => import('@/views/pc/Book')
  },
  {
    path: 'm/book/:id',
    name: 'mobileBook',
    component: () => import('@/views/mobile/Book')
  },
  {
    path: 'm/book/:id/:chapterId',
    name: 'mobileBookContent',
    component: () => import('@/views/mobile/BookContent')
  },
  {
    path: 'm/chapter_list/:bookId',
    name: 'mobileChapterList',
    component: () => import('@/views/mobile/ChapterList')
  },
  {
    path: 'chapter_list/:bookId',
    name: 'chapterList',
    component: () => import('@/views/pc/ChapterList')
  },
  {
    path: 'book/:id/:chapterId',
    name: 'bookContent',
    component: () => import('@/views/pc/BookContent')
  },
  {
    path: 'user/setup',
    name: 'userSetup',
    component: () => import('@/views/pc/UserSetup')
  },
  {
    path: 'user/orders',
    name: 'userOrders',
    component: () => import('@/views/pc/PayOrders')
  },
  {
    path: 'm/user/setup',
    name: 'mobileUserSetup',
    component: () => import('@/views/mobile/UserSetup')
  },
  {
    path: 'm/user/orders',
    name: 'mobileUserOrders',
    component: () => import('@/views/mobile/PayOrders')
  },
  {
    path: 'recharge',
    name: 'recharge',
    component: () => import('@/views/pc/Recharge')
  },
  {
    path: 'bookshelf',
    name: 'bookshelf',
    component: () => import('@/views/pc/Bookshelf')
  },
  {
    path: 'm/recharge',
    name: 'mobileRecharge',
    component: () => import('@/views/mobile/Recharge')
  },
  {
    path: 'm/bookshelf',
    name: 'mobileBookshelf',
    component: () => import('@/views/mobile/Bookshelf')
  },
  {
    path: 'm/member',
    name: 'mobileMember',
    component: () => import('@/views/mobile/Member')
  },
  {
    path: 'member',
    name: 'member',
    component: () => import('@/views/pc/Member')
  },
  {
    path: 'payment_result',
    name: 'paymentResult',
    component: () => import('@/views/pc/PaymentResult')
  },
  {
    path: 'm/payment_result',
    name: 'mobilePaymentResult',
    component: () => import('@/views/mobile/PaymentResult')
  }
]
